// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../types/schema';

import { BeneficiariesReport_EstateWaterfallFragment, BeneficiariesReport_EstateWaterfallBeneficiaryReportFragment } from '../../../../../../beneficiaryReport/graphql/BeneficiariesReport.generated';
import { gql } from '@apollo/client';
import { BeneficiariesReport_EstateWaterfallFragmentDoc, BeneficiariesReport_EstateWaterfallBeneficiaryReportFragmentDoc } from '../../../../../../beneficiaryReport/graphql/BeneficiariesReport.generated';
export type ClientPresentation_BeneficiaryReport_EstateWaterfallFragment = (
  { __typename?: 'EstateWaterfall', id: string, displayName: string, kind?: Types.EstateWaterfallKind | null, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, beneficiaryReport: (
    { __typename?: 'EstateWaterfallBeneficiaryReport', materializedInputParams: { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null } }
    & ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragment
  ), growthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null }
  & BeneficiariesReport_EstateWaterfallFragment
);

export type ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragment = (
  { __typename?: 'EstateWaterfallBeneficiaryReport', _cacheKey: string }
  & BeneficiariesReport_EstateWaterfallBeneficiaryReportFragment
);

export const Operations = {
  Fragment: {
    ClientPresentation_BeneficiaryReport_EstateWaterfall: 'ClientPresentation_BeneficiaryReport_EstateWaterfall' as const,
    ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReport: 'ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReport' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragmentDoc = gql`
    fragment ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReport on EstateWaterfallBeneficiaryReport {
  _cacheKey
  ...BeneficiariesReport_EstateWaterfallBeneficiaryReport
}
    ${BeneficiariesReport_EstateWaterfallBeneficiaryReportFragmentDoc}`;
export const ClientPresentation_BeneficiaryReport_EstateWaterfallFragmentDoc = gql`
    fragment ClientPresentation_BeneficiaryReport_EstateWaterfall on EstateWaterfall {
  ...BeneficiariesReport_EstateWaterfall
  id
  displayName
  beneficiaryReport {
    ...ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReport
    materializedInputParams {
      firstGrantorDeathYear
      secondGrantorDeathYear
      selectedGrowthProfile {
        id
        displayName
      }
    }
  }
  growthProfile {
    id
    displayName
  }
  kind
  firstGrantorDeathYear
  secondGrantorDeathYear
}
    ${BeneficiariesReport_EstateWaterfallFragmentDoc}
${ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragmentDoc}`;